import { render, staticRenderFns } from "./WhatsappList.vue?vue&type=template&id=2691f183&"
import script from "./WhatsappList.vue?vue&type=script&lang=js&"
export * from "./WhatsappList.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports